module.exports = __webpack_public_path__ + "static/img/15.2642077.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/zh/15.png
// module id = oDAm
// module chunks = 0